import { motion, useScroll, useSpring } from "framer-motion";

const LINKS = [
  { label: "CAPABILITIES", href: "#capabilities", testid: "nav-link-capabilities" },
  { label: "CONTACT", href: "#contact", testid: "nav-link-contact" },
];

export default function Navbar() {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.4 });

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-orange-500/15 bg-[#050505]/80 backdrop-blur-md">
      <motion.div
        className="absolute inset-x-0 top-0 h-[2px] origin-left bg-orange-500"
        style={{ scaleX: progress }}
        data-testid="nav-scroll-progress"
      />
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-display text-xl font-bold uppercase tracking-[0.15em] text-stone-100 transition-colors duration-300 hover:text-orange-500"
        >
          KB<span className="text-orange-500">/</span>XDU
        </a>
        <div className="flex items-center gap-5 sm:gap-8">
          <span className="hidden items-center gap-2 text-[10px] tracking-[0.3em] text-stone-500 md:flex" data-testid="nav-status">
            <span className="animate-blink inline-block h-1.5 w-1.5 rounded-full bg-orange-500" />
            SYS.ONLINE
          </span>
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-[10px] tracking-[0.3em] text-stone-400 transition-colors duration-300 hover:text-orange-500 sm:text-xs"
            >
              {l.label}
            </a>
          ))}
        </div>
      </nav>
    </header>
  );
}
